export default [
    {
        path: '/scheduler/runs',
        name: 'RunsScheduler',
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: null,
            title: 'Runs',
            fullWidth: true,
        },
        components: {
            default: () => import('@views/scheduler/runs/SchedulerIndex.vue'),
        },
    },
];
